import { TooltipProvider } from "@reactive-resume/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router";

import { helmetContext } from "../constants/helmet";
import { queryClient } from "../libs/query-client";
import { AuthRefreshProvider } from "./auth-refresh";
import { DialogProvider } from "./dialog";
import { LocaleProvider } from "./locale";
import { ThemeProvider } from "./theme";
import { Toaster } from "./toaster";
import { TokenAuthProvider } from "./token-auth";

export const Providers = () => (
  <LocaleProvider>
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <TokenAuthProvider>
          <AuthRefreshProvider>
            <ThemeProvider>
              <TooltipProvider>
                <DialogProvider>
                  <Outlet />

                  <Toaster />
                </DialogProvider>
              </TooltipProvider>
            </ThemeProvider>
          </AuthRefreshProvider>
        </TokenAuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </LocaleProvider>
);
